import { createSlice } from "@reduxjs/toolkit";

export const initialData = {
  isOpenLoginModal: false,
};

const dataSlice = createSlice({
  name: "modal",
  initialState: initialData,
  reducers: {
    openLoginModal: (state, action) => {
      state.isOpenLoginModal = true;
    },
    closeLoginModal: (state, action) => {
      state.isOpenLoginModal = false;
    },
    // openBuyNowModal: (state, action) => {
    //   state.isOpenBuyNowModal = true;
    // },
    // closeBuyNowModal: (state, action) => {
    //   state.isOpenBuyNowModal = false;
    // },
    closeAllModal: (state, action) => {
      state.isOpenLoginModal = false;
      state.isOpenBuyNowModal = false;
    },
    setAnimationModal: (state, action) => {
      state.isAnimationModal = action.payload;
    },
    setShowModal: (state, action) => {
      state.showModal = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  openLoginModal,
  closeLoginModal,
  // openBuyNowModal,
  // closeBuyNowModal,
  closeAllModal,
  setAnimationModal,
  setShowModal,
} = dataSlice.actions;

export default dataSlice.reducer;
